<template>
  <div class="container mx-auto flex flex-col-reverse md:flex-row py-5 md:py-10 md:mt-10">
    <!-- Contact details -->
    <ContactDetails :contacts="contacts" />
    <!-- Contact form -->
    <ContactForm />
  </div>
</template>


<script>
import feather from 'feather-icons';
import ContactForm from '@/components/contact/ContactForm.vue';
import ContactDetails from '@/components/contact/ContactDetails.vue';

export default {
  components: {
    ContactForm,
    ContactDetails,
  },
  data: () => {
    return {
      contacts: [
        {
          id: 1,
          name: 'Vancouver, Canada',
          icon: 'map-pin',
        },
        {
          id: 2,
          name: 'takanori.fujiki@gmail.com',
          icon: 'mail',
          opneTab: true,
          link: 'mailto:takanori.fujiki@gmail.com',
        },
        {
          id: 3,
          name: '(604) 704 - 3492',
          icon: 'phone',
          opneTab: true,
          link: 'tel:+16047043492',
        },
        {
          id: 4,
          name: 'github.com/TKNRFJK1208',
          icon: 'github',
          opneTab: true,
          link: 'https://github.com/TKNRFJK1208',
        },
        {
          id: 5,
          name: 'linkedin.com/in/takanori-fujiki-a06ab727a',
          icon: 'linkedin',
          opneTab: true,
          link: 'https://linkedin.com/in/takanori-fujiki-a06ab727a',
        },
        {
          id: 6,
          name: 'x.com/taka_abroad',
          icon: 'twitter',
          opneTab: true,
          link: 'https://x.com/taka_abroad',
        },
        {
          id: 7,
          name: 'zenn.dev/takanori_fujiki',
          icon: 'book',
          opneTab: true,
          link: 'https://zenn.dev/tfuji',
        }
      ]
    };
  },
  mounted() {
    feather.replace();
  },
  updated() {
    feather.replace();
  }
}
</script>